export default __webpack_public_path__ + "static/gecko-logo-white-e0c822766ddaf0f13eec0b8799f91d06.svg";